import React from "react";
import {
  Box,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
} from "@mui/material";
import { StepContent } from "../../styles/StyledComponents";
import { STATUS_LAVORATIVO } from "../../constants";

const StatusOption = ({ value, label, formData, setFormData }) => {
  return (
    <Box
      sx={{
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        p: 2,
        mb: 2,
        cursor: "pointer",
        transition: "all 0.2s",
        backgroundColor: (theme) =>
          formData.statusLavorativo === value
            ? theme.palette.mode === "light"
              ? "#fff3e0"
              : "rgba(255, 152, 0, 0.1)"
            : "transparent",
        borderColor:
          formData.statusLavorativo === value ? "#ff9800" : undefined,
        "&:hover": {
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? "#f5f5f5"
              : "rgba(255, 255, 255, 0.05)",
        },
      }}
      onClick={() => setFormData({ ...formData, statusLavorativo: value })}
    >
      <FormControlLabel
        value={value}
        control={
          <Radio
            sx={{
              color: "#ff9800",
              "&.Mui-checked": { color: "#ff6f00" },
            }}
          />
        }
        label={label}
        sx={{ m: 0, width: "100%" }}
      />
    </Box>
  );
};

const Step2Lavoro = ({ formData, setFormData, handleInputChange }) => {
  return (
    <StepContent>
      <Typography variant="body1" sx={{ fontWeight: 500, mb: 2 }}>
        Qual è il tuo status? *
      </Typography>

      <RadioGroup
        value={formData.statusLavorativo}
        onChange={handleInputChange("statusLavorativo")}
      >
        {STATUS_LAVORATIVO.map((status) => (
          <StatusOption
            key={status.value}
            value={status.value}
            label={status.label}
            formData={formData}
            setFormData={setFormData}
          />
        ))}
      </RadioGroup>
    </StepContent>
  );
};

export default Step2Lavoro;
